module.exports = __webpack_public_path__ + "img/bg.8e801aa0.png";